import { CommonHelper } from "../../../react-core/Helpers/CommonHelper";
import { Address } from "../../../Wrap/Models/Domains/Address/Address";
import { PostCodeAnywhereAddressDetails } from "../../../Wrap/Models/Domains/Address/PostCodeAnywhereAddressDetails";

export class AddressHelper {
    static GetFormattedAddressLine1(address: Address): string {
        return address.Line1;
    }

    static GetFormattedAddressLine2(address: Address): string {
        return address.Line2;
    }

    static GetFormattedAddressLine3(address: Address, pcaResult: PostCodeAnywhereAddressDetails): string {
        const addressLines = [address.Line3, address.Line4, address.Line5, address.Line6];
        const notNullAddressLines = addressLines.filter((x) => !CommonHelper.isNullOrEmpty(x));
        const joinedAddress = notNullAddressLines.join(", ");
        const MAXCHARNO = 35;

        const addressLineWithProvince =
            CommonHelper.isNullOrEmpty(pcaResult.ProvinceName) ||
            CommonHelper.isNullOrEmpty(joinedAddress) ||
            notNullAddressLines.some((x) => x.toUpperCase() == pcaResult?.ProvinceName.toUpperCase())
                ? joinedAddress
                : joinedAddress + ", " + pcaResult.ProvinceName;
        if (joinedAddress.length > MAXCHARNO) {
            const addressLine3 = address.Line3;
            const trimedLine = addressLine3.substring(0, MAXCHARNO);
            return addressLine3.length > MAXCHARNO ? trimedLine : addressLine3;
        } else if (addressLineWithProvince != joinedAddress && addressLineWithProvince.length <= MAXCHARNO) {
            return addressLineWithProvince;
        } else {
            return joinedAddress;
        }
    }
}
